//VIDEO METADATA
export const ADD_CURR = "add_curr";
export const ADD_VIDEO_META_DATA = "add_video_meta_data";
export const RESET_VIDEO_META_DATA = "reset_video_meta_data";
export const UPDATE_VIDEO_META_DATA = "update_video_meta_data";
export const ADD_BULK_VIDEO_META_DATA = "add_bulk_video_meta_data";
